import styled from 'styled-components'

export const TimeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`
